import orderBy from 'lodash/orderBy';
import getCardTitle from './getCardTitle';

const pullArticlesWithLongestHeadlines = river =>
  orderBy(river, card => getCardTitle(card).split(' ').length, 'desc').slice(0, 5);

export default pullArticlesWithLongestHeadlines;
